// extracted by mini-css-extract-plugin
export default {"products":"Products_products__Pr3Iq","title":"Products_title__QjpG5","productList":"Products_productList__0WYfj","header":"Products_header__wkFCO"};